import styled from 'styled-components';

export const Text = styled.p`
  color: #fff;
  margin: 16px 0;
`;
